export const CLERK_USER_RELOAD_INTERVAL_MS = 24 * 60 * 60 * 1000;

export function clerkUserReloadStorageKey(userId: string): string {
  return `clerk-user-reloaded-at:${userId}`;
}

export function parseClerkUserReloadTimestamp(value: string | null): number | null {
  if (!value) return null;

  const timestamp = Number(value);
  return Number.isFinite(timestamp) && timestamp > 0 ? timestamp : null;
}

export function isClerkUserReloadDue(
  lastReloadedAt: number | null,
  now = Date.now()
): boolean {
  if (lastReloadedAt === null) return true;
  if (lastReloadedAt > now) return true;

  return now - lastReloadedAt >= CLERK_USER_RELOAD_INTERVAL_MS;
}

export function readStoredClerkUserReloadAt(userId: string): number | null {
  if (typeof window === "undefined") return null;

  try {
    return parseClerkUserReloadTimestamp(
      window.localStorage.getItem(clerkUserReloadStorageKey(userId))
    );
  } catch {
    return null;
  }
}

export function writeStoredClerkUserReloadAt(userId: string, reloadedAt: number): void {
  if (typeof window === "undefined") return;

  try {
    window.localStorage.setItem(clerkUserReloadStorageKey(userId), String(reloadedAt));
  } catch {
    // localStorage가 막힌 환경에서는 현재 탭의 메모리 가드에만 의존한다.
  }
}
